import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/rupee.svg'


const _withScopeId = n => (_pushScopeId("data-v-74e67823"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "job-list" }
const _hoisted_2 = { class: "salary" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "rupee-icon"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quis officia facere iusto, qui reprehenderit distinctio esse dolore nostrum ab sapiente deserunt, sequi, hic tempore a sint dolor unde nemo! Quidem. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", null, "Ordered by " + _toDisplayString(_ctx.order), 1),
      _createVNode(_TransitionGroup, {
        name: "list",
        tag: "ul"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedJobs, (job) => {
            return (_openBlock(), _createElementBlock("li", {
              key: job.id
            }, [
              _createElementVNode("h2", null, _toDisplayString(job.title) + " in " + _toDisplayString(job.location), 1),
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("p", null, _toDisplayString(job.salary) + " rupees", 1)
              ]),
              _hoisted_4
            ]))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}